'use strict';

// pageLinkコンポーネントにページ内リンクを生成
function initAnchor() {
    const list = $('ul.myaccount__nav-list#page-link');
    if (list.length) {
        const anchors = $('div.anchorlink');
        for (let i = 0; i < anchors.length; i++) {
            anchors.eq(i).attr('id', 'anchor' + i);
            const html = '<li>'
                         + '<a class="anchor" href="#anchor' + i + '">'
                         + anchors.eq(i).text()
                         + '</a>'
                         + '</li>';
            list.append(html);
        }
    }
}

// メニューに画像を生成
function initImage() {
    // navigationが複数入る場合がある
    const navList = $('ul.myaccount__nav-list');
    const image = $('div.myaccount-row-nav').data('url');
    if (navList.length) {
        for (let i = 0; i < navList.length; i++) {
            navList.eq(i).find('a').each(function( index, element ) {
                $(element).append('<img src="' + image + '">');
            });
        }
    } 
}

$(() => {
    $('.faq-parts-qa__q').click(function () {
        $(this).toggleClass('active');
        $(this).next('.faq-parts-qa__a').slideToggle();
    });
    
    initAnchor();
    initImage();
});
